import { useTranslation } from 'react-i18next';
import { Text } from '@veo/web-design-system';
import { StatsPlaceholder } from './components/placeholder/placeholder';
import styles from './player-stats.module.scss';

export function PlayerStats() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Text
        size="h1"
        weight="bold"
        type="h2"
        className={styles.title}
      >
        {t('player_stats.heading')}
      </Text>
      <StatsPlaceholder />
    </div>
  );
}
